<mat-dialog-content>
  <div class="insight-container">
    <div class="insight-title">
      <div class="title">Confirmation</div>
      <div class="insight-title-icon"><mat-icon>close</mat-icon></div>
    </div>
    <div class="insight-title-main">Validation doc</div>
    <div class="insight-content">
      <div class="insight-text">
        Would you like to verify the evidence? It's essential to ensure that all the evidence has been updated correctly.
      </div>
      <mat-dialog-actions>
        <button mat-button class="cra-button button-light" [mat-dialog-close]="false" >Cancel</button>
        <button mat-button class="cra-button button-dark" [mat-dialog-close]="true">Confirm</button>
      </mat-dialog-actions>
    </div>
  </div>
</mat-dialog-content>
